<panel width="650">
  <h1>{{ 'sync-data.synchronize-data-between-environments' | translate }}</h1>
  @if (loading) {
    <skeletons [defaultSkeletons]="4" />
  }

  @if (!loading && (!sourceDatabase || !targetDatabase)) {
    <section>
      <custom-input [label]="'sync-data.copy-historical-data' | translate" [inputType]="inputTypeEnum.Switch" [(value)]="copyHistoricalData" />
      <custom-input [label]="'sync-data.use-manual-source' | translate" [inputType]="inputTypeEnum.Switch" [(value)]="useManualSource" />
      <custom-select [label]="'sync-data.database' | translate"
        [selectList]="databasesList"
        [(value)]="selectedDatabase"
      [required]="true"></custom-select>
      @if (!useManualSource) {
        <custom-select
          [label]="'sync-data.environment' | translate"
          [selectList]="environmentsList"
          [(value)]="selectedEnvironment"
        [required]="true"></custom-select>
      }
      @if (useManualSource) {
        <custom-input
          [label]="'sync-data.manual-source' | translate"
          [(value)]="manualSource"
          [inputType]="inputTypeEnum.Text"
        [required]="true"></custom-input>
      }
    </section>
    <section>
      <button (click)="getDatabaseOverview()" [label]="'sync-data.get-database-overview' | translate"></button>
    </section>
  }
  @if (!loading && sourceDatabase && targetDatabase) {
    <scrollable>
      <div style="position: relative;">
        <soft-popup [showPopup]="showPropertySelector" [width]="580" [top]="propertySelectorOffsetTop" [left]="350">
          <div class="row" style="padding: 10px;">
            @for (property of filteredTargetProperties; track property) {
              <div class="col-12">
                <a (click)="setMatchedProperty(property.targetTable, property.targetProperty)">{{ 'sync-data.import-to' | translate: { table: property.targetTable, property: property.targetProperty } }}</a>
              </div>
            }
          </div>
        </soft-popup>
        @if (!loading && sourceDatabase && targetDatabase) {
          <list-view [selectable]="false">
            <header [sortColumn]="false">{{ 'general.status' | translate }}</header>
            <header defaultSort="ascending">{{ 'sync-data.table' | translate }}</header>
            <header>{{ 'sync-data.columns' | translate }}</header>
            <ng-container *listData="let table from sourceDatabase">
              <row (action)="table.expanded = table.expanded ? false : true" [statusIcon]="table.expanded ? 'chevron-down' : 'chevron-right'" statusColor="color-blue-50">
                <column>{{ 'sync-data.status.' + getStatus(table) | translate}}</column>
                <column>{{ table.tablename }}</column>
                <column>{{ table.columns.length }}</column>
              </row>
              <row-details [hidden]="!table.expanded">
                <button small reject [loader]="false" [ignoreValidation]="true" (click)="clearTable(table)">{{'sync-data.clear-choices' | translate}}</button>
                @for (column of table.columns; track column) {
                  <div>
                    <button small [loader]="false" [ignoreValidation]="true" [attr.ghost]="getMatch(table, column) ? null : ''" (click)="openPropertySelector(table, column, $event)" style="min-width: 250px;">{{column}}: {{getMatch(table, column) ? ('sync-data.matched' | translate: getMatch(table, column)) : ('sync-data.not-matched' | translate) }}</button>
                  </div>
                }
              </row-details>
            </ng-container>
          </list-view>
        }
      </div>
    </scrollable>
    <section>
      <button confirm #copyButton (click)="clearAndCopyData()" [label]="'sync-data.clear-data-and-copy' | translate" [ignoreValidation]="true"></button>
    </section>
  }
</panel>
